export interface DeviceToken {
  id: string;
  platform: string;
  app_version: string;
  updated_at: string;
  device_model?: string;
  os_version?: string;
  user_agent?: string;
}

export interface UserFormInitialValues {
  id?: string;
  is_active: boolean;
  email: string;
  groups: string[];
  group_names: string[];
  first_name: string;
  last_name: string;
  /** Absolute URL of the user's avatar; serialized by `/api/v2/user/`. */
  profile_photo?: string | null;
  is_staff: boolean;
  is_superuser: boolean;
  current_school: string | null;
  current_location: string | null;
  cell_phone: string | null;
  last_answer_update: string | null;
  permissions: number[];
  user_type: string;
  is_removed: boolean;
  deleted: string | null;
  is_vip: boolean;
  district: string | null;
  is_role_user: boolean;
  expiring_fcm_tokens: DeviceToken[];
  is_sso_login: boolean;
  is_locked: boolean;
  is_concealed_carry: boolean;
  disable_sso: boolean;
  permissions_version: number;
  permissions_updated_at: string;
  has_alertlocation: boolean;
  user_room_status: string | null;
  needs_medical_attention: boolean;
  is_on_duty: boolean;
  user_duty_id: number;
  password?: string;
  confirm_password?: string;
  schools: number[];
  vendor_id?: number | null;
  vendor_name?: string | null;
  has_elevated_sms_access?: boolean;
  toggle_alert_drills_and_updates_push_notification?: boolean;
  toggle_initial_direct_chat_and_mentions_push_notification?: boolean;
  toggle_all_chats_push_notification?: boolean;
}
export interface User {
  id?: number;
  groups?: number[];
  first_name?: string;
  last_name?: string;
  password?: string;
  confirm_password?: string;
  email?: string;
}
export const UserInitialValues = {
  id: '',
  groups: [],
  first_name: '',
  last_name: '',
  password: '',
  confirm_password: '',
  email: '',
  schools: [],
};
// Function to merge initial values with existing user data
export const getUserFormValues = (user?: User) => {
  return {
    ...UserInitialValues,
    ...user,
    password: '',
    confirm_password: '',
  };
};
